import { render, staticRenderFns } from "./ContasForm.vue?vue&type=template&id=5995dbd2"
import script from "./ContasForm.vue?vue&type=script&lang=js"
export * from "./ContasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports